<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon :name="icon" :style="iconColor"></sym-icon></span>
		<div class="fi-row-message">
			<span v-if="declined" class="forceinfoAlert">{{ responsible }} {{ env.msg('forceInfo.userDeclined') }}</span>
			<span v-else class="forceinfoHighlighted">{{ responsible }} {{ env.msg(fi.srcType === SrcType.EVENT ? "forceInfo.userConfirmed" : "forceInfo.userAccepted") }}</span>

			<span v-if="fi.srcType === SrcType.TASK">{{ env.msg('forceInfo.dTask') }}:</span>
			<span v-else-if="fi.srcType === SrcType.EVENT">{{ env.msg('forceInfo.dEvent') }}:</span>
			<span v-else-if="fi.srcType === SrcType.CONTACT">{{ env.msg('forceInfo.dContact') }}:</span>
			<span v-else-if="fi.srcType === SrcType.OPPORTUNITY">{{ env.msg('forceInfo.dOpportunity') }}:</span>
			<span v-else-if="fi.srcType === SrcType.BUSCASE">{{ env.msg('forceInfo.dBusCase') }}:</span>

			<object-link :src-id="fi.srcId" :src-type="fi.srcType">{{ fi.srcName }}</object-link>

			<a href="#" class="fbutton" @click.prevent="deleteFi">{{ env.msg('butt.ok') }}</a>
			<fi-date :value="fi.entered"></fi-date>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {DECLINED, ForceInfo} from "@t/processes/ForceInfo.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import {injectEnv} from "@fd/Environment.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import FiDate from "@/processes/FiDate.vue";
import {useForceInfoStore} from "@/store/ForceInfoStore";

const props = defineProps<{
	fi:ForceInfo,
	responsible: string
}>();
const env = injectEnv();
const fis = useForceInfoStore();

const declined = computed<boolean>(() => DECLINED.toString() === props.fi.value);
const icon = computed<string>(() => declined.value ? "thumb-down" : "thumb-up" );
const iconColor = computed<string>(() => declined.value ? "color:var(--red)" : "color:var(--green)" );

function deleteFi() {
	fis.deleteForceInfo(props.fi.id);
}
</script>

<style>

</style>